// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"35d4383c","312":"c4a26fce","453":"8ab44547","842":"11ad7902"}[chunkId] + ".chunk.js";
};